import { render } from "./matching-card-background.vue?vue&type=template&id=4aa0e408&scoped=true&ts=true"
import script from "./matching-card-background.vue?vue&type=script&lang=ts"
export * from "./matching-card-background.vue?vue&type=script&lang=ts"

import "./matching-card-background.vue?vue&type=style&index=0&id=4aa0e408&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa0e408"]])

export default __exports__